'use strict';

var marked = require('marked');

module.exports = function(element, binding) {
  element.innerHTML = marked(binding.value, {
    gfm: true
  });
};



//////////////////
// WEBPACK FOOTER
// ./src/scripts/shared/directives/markdown.js
// module id = 203
// module chunks = 0